/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ months: NonNullable<unknown> }} Dashboard_Age_Months_PlusInputs */

const en_dashboard_age_months_plus = /** @type {(inputs: Dashboard_Age_Months_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months}+ mo`)
};

const pt_br2_dashboard_age_months_plus = /** @type {(inputs: Dashboard_Age_Months_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months}+ meses`)
};

/**
* | output |
* | --- |
* | "{months}+ mo" |
*
* @param {Dashboard_Age_Months_PlusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_age_months_plus = /** @type {((inputs: Dashboard_Age_Months_PlusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Age_Months_PlusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_age_months_plus(inputs)
	return pt_br2_dashboard_age_months_plus(inputs)
});